import { createTypedEnum } from '@reckon-web/formschema-enums';

export const OutstandingTasksEnum = createTypedEnum({
  Cancel: 'Cancel',
  Completed: 'Completed',
  Nothing: 'Nothing',
} as const);
export type OutstandingTasksEnumValue =
  (typeof OutstandingTasksEnum.values)[number];
export type OutstandingTasksEnumLabel =
  (typeof OutstandingTasksEnum.labels)[number];
